import React from 'react';

export default function PaketBiaya() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Paket & Biaya</h1>
      <p className="text-gray-500">Halaman Paket & Biaya</p>
    </div>
  );
}
